export default "__VITE_ASSET__BDJ8BUJk__"